import { TableCell } from '@mui/material';

export const HeaderTableCell = ({ value, index, position = 'left' }) => {
    return (
        <TableCell
            key={index}
            style={{
                fontFamily: 'Montserrat',
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: '14px',
                lineHeight: '17px',
                color: '#A8B6C1',
                textAlign: position,
                backgroundColor: '#F1F3F7',
                height: '50px'
            }}>
            {value}
        </TableCell>
    );
};
